    <div class="g-container">
        <p-confirmDialog />
        <div class="overlay" *ngIf="loadingProject">
            <p-progressSpinner styleClass="large-spinner"></p-progressSpinner>
        </div>

        <!-- Project Hero -->
        <div class="project-hero">
            <div class="hero-content">
                <h1 class="project-name">
                    {{ project?.name || ('project.card.project' | transloco) }}
                </h1>
            </div>
        </div>

        <!-- Gallery + Profile -->
        <div class="project-main">
            <div class="project-gallery">
                <div class="main-image" (click)="openImage(selectedImage ?? '')">
                    <i class="pi pi-search-plus zoom-icon"></i>
                    <p-skeleton styleClass="skel" height="360px" width="100%" *ngIf="loadingProject" />
                    <img [src]="selectedImage ?? project?.images?.[0]?.href" *ngIf="!loadingProject">
                </div>
                <div class="thumbs-navigation">
                    <button class="thumb-nav-btn" (click)="prevThumbs()" [disabled]="thumbStart === 0">
                        <i class="pi pi-chevron-left"></i>
                    </button>
                    <div class="thumbs">
                        <img *ngFor="let img of visibleThumbs"
                            [src]="img.thumbHref ?? img.href"
                            [class.selected]="img.href === selectedImage"
                            (click)="selectImage(img.href ?? '')"
                            (error)="img.thumbHref = img.href" />
                        <p-skeleton styleClass="skel" height="68px" width="68px" *ngIf="loadingProject" />
                        <p-skeleton styleClass="skel" height="68px" width="68px" *ngIf="loadingProject" />
                        <p-skeleton styleClass="skel" height="68px" width="68px" *ngIf="loadingProject" />
                    </div>
                    <button class="thumb-nav-btn" (click)="nextThumbs()"
                        [disabled]="thumbStart + visibleCount >= (project?.images?.length || 0)">
                        <i class="pi pi-chevron-right"></i>
                    </button>
                </div>
            </div>

            <div class="project-profile">
                <div class="profile-row">
                    <img [src]="project?.images?.[0]?.thumbHref ?? project?.images?.[0]?.href" class="profile-img" *ngIf="!loadingProject" (error)="project!.images![0].thumbHref = project!.images![0].href">
                     <p-skeleton styleClass="skel circle" height="48px" width="48px" *ngIf="loadingProject" />
                     <div class="profile-name">{{'project.card.by' | transloco}} {{userName}}</div>
                </div>
                <div class="profile-section">
                    <span class="section-label">{{ "tasks.tableShare.description" | transloco }}</span>
                    <div class="profile-desc">
                        {{ project?.detail || ('project.card.projectDescription' | transloco) }}
                    </div>
                </div>
                <div class="profile-section">
                    <span class="section-label">Tags</span>
                    <div class="tags">
                        <span class="tag" *ngFor="let tag of project?.tags">#{{ tag }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Vehicle Data -->
        <div class="content-section">
            <div class="section-header-modern">
                <div class="section-title-row">
                    <i class="pi pi-car section-icon"></i>
                    <h2 class="section-title">{{ 'project.detail.tabVehicle.header' | transloco }}</h2>
                </div>
            </div>
            <div class="vehicle-info-grid">
                <div class="vehicle-info-card">
                    <i class="pi pi-building vehicle-info-icon"></i>
                    <span class="vehicle-info-label">{{ 'project.detail.tabVehicle.manufacturer' | transloco }}</span>
                    <span class="vehicle-info-value">{{ project?.vehicle?.manufacturer || '—' }}</span>
                </div>
                <div class="vehicle-info-card">
                    <i class="pi pi-car vehicle-info-icon"></i>
                    <span class="vehicle-info-label">{{ 'project.detail.tabVehicle.model' | transloco }}</span>
                    <span class="vehicle-info-value">{{ project?.vehicle?.model || '—' }}</span>
                </div>
                <div class="vehicle-info-card">
                    <i class="pi pi-calendar vehicle-info-icon"></i>
                    <span class="vehicle-info-label">{{ 'project.detail.tabVehicle.year' | transloco }}</span>
                    <span class="vehicle-info-value">{{ (project?.vehicle?.yearDate | date:'yyyy') || '—' }}</span>
                </div>
            </div>
        </div>

        <!-- VCU -->
        <div class="content-section" *ngIf="vcus && vcus.length > 0">
            <div class="section-header-modern">
                <div class="section-title-row">
                    <i class="pi pi-microchip section-icon"></i>
                    <h2 class="section-title">{{ 'project.detail.vcu' | transloco }}</h2>
                </div>
            </div>
            <div class="vcu-grid">
                <div class="vcu-grid-item" *ngFor="let vcu of vcus">
                    <app-card-vcu [vcu]="vcu" [showUnlink]="false" [sharing]="false" [details]="true"></app-card-vcu>
                </div>
            </div>
        </div>
    </div>

    <!-- Image Lightbox -->
    <div class="lightbox-overlay" *ngIf="displayImage" (click)="closeLightbox($event)"
         (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
        <button class="lightbox-close" (click)="displayImage = false">
            <i class="pi pi-times"></i>
        </button>

        <button class="lightbox-nav lightbox-prev" (click)="lightboxPrev($event)"
                *ngIf="(project?.images?.length ?? 0) > 1">
            <i class="pi pi-chevron-left"></i>
        </button>

        <div class="lightbox-content">
            <img [src]="imageSelectedUrl" class="lightbox-image" (click)="$event.stopPropagation()" />
            <div class="lightbox-counter" *ngIf="(project?.images?.length ?? 0) > 1">
                {{ lightboxIndex + 1 }} / {{ project?.images?.length }}
            </div>
        </div>

        <button class="lightbox-nav lightbox-next" (click)="lightboxNext($event)"
                *ngIf="(project?.images?.length ?? 0) > 1">
            <i class="pi pi-chevron-right"></i>
        </button>

        <div class="lightbox-thumbs" *ngIf="(project?.images?.length ?? 0) > 1"
             (click)="$event.stopPropagation()">
            <img *ngFor="let img of project?.images ?? []; let i = index"
                 [src]="img.href" [class.active]="i === lightboxIndex"
                 (click)="lightboxGoTo(i)" />
        </div>
    </div>

